$mol_view_tree2_to_js_test_ex_array_indexed_foo $mol_object
	tags* /string
		<= tag1* \t1
		^ slot* /
			<= tag2* \t2
